document.addEventListener('DOMContentLoaded', function () { 

  /** splide slider */
  var splideElms = document.querySelectorAll( '.splide' );
  if (splideElms) { 

    splideElms.forEach(e => {

      let enableScrollExt;
      if(e.classList.contains('auto-scroll')) {  
        enableScrollExt = window.splide.Extensions;
      }
      let splideSettings = e.dataset.splide; 
      if(splideSettings != null) { 
        new Splide( e , splideSettings ).mount( enableScrollExt );
      }

    });

  }

  /** read more */
  const readMoreBtn = document.querySelectorAll(".read-more");
  if (readMoreBtn) { 
    readMoreBtn.forEach(e => {
      
      /** remove read more btn if fullContent characters is less than 200 */
      if (e.closest('.review-card__body').querySelector('.full-content').textContent.length < 400) {
        e.remove();
      }

      e.addEventListener("click", function() { 

        let parent = this.closest('.review-card__body'); /** gets the parent of element that fired the event */
        let fullContent = parent.querySelector('.full-content');  /** gets element that has full content */
        let truncatedContent = parent.querySelector(".truncated-content"); /** gets element that has truncated content */
        let toString = fullContent.classList.toString(); /** convert the classList into string, note: includes() function can only test in string */
        let condition = toString.includes("visually-hidden"); /** test if fullContent has the classList of "visually-hidden" */

        /**
          if condition equals true, it will remove the class of "visually-hidden"
          in fullContent, add a classList "visually-hidden" in truncatedContent, 
          and change btn text content into "Read less". Otherwise, it will add the  
          classList "visually-hidden" in fullContent, remove classList "visually-hidden"
          in truncatedContent, and change btn text content into "Read more".
        */
        if (condition == true ) { 
          fullContent.classList.remove("visually-hidden");
          truncatedContent.classList.add("visually-hidden");
          this.textContent = "Read less";       
        } 
        else { 
          fullContent.classList.add("visually-hidden");
          truncatedContent.classList.remove("visually-hidden");
          this.textContent = "Read more";       
        }
        
      });

    }); 
  }

  /** updates product variant */
  var radioInputs = document.querySelectorAll('fieldset.product-form__input input[type="radio"]');
  radioInputs.forEach(function(radioInput) {
    radioInput.addEventListener('change', function() {
      var optionName = this.closest('fieldset').querySelector('input[type="radio"]:checked').value;
      var updateOptionName = this.closest('fieldset').querySelector('#variant-name');
      updateOptionName.textContent = optionName;
    });
  });

  /** custom play button */
  const btns = document.querySelectorAll(".video-metafield .metafield-play-button");

  btns.forEach(btn => {
    btn.addEventListener("click", function() {
      const vid = this.closest(".video-metafield").querySelector("video");
      const playBtn = this.querySelector("span");
      if (vid.paused == true) {
        playBtn.style.display = 'none';
        vid.setAttribute("controls", "true");
        vid.play();
      }
    });
  });

})